import React, {useState,useEffect} from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Routes from "./Routes";
import { LinkContainer } from "react-router-bootstrap";
import { AppContext } from "./libs/contextLib";
import {Auth} from "aws-amplify";
import { onError } from "./../src/libs/errorLib";
import "./App.css";
import { useHistory } from "react-router-dom";

function App() {
  const [isAuthenticating, setIsAuthenticating] = useState(true);
  const [isAuthenticated, userHasAuthenticated] = useState(false);
  const history = useHistory();
  useEffect(() => {
    onLoad();
  }, []);
  async function onLoad() {
    try {
      await Auth.currentSession();
      userHasAuthenticated(true);
    }
    catch(e) {
      if (e !== 'No current user') {
        onError(e);
      }
    }
  
    setIsAuthenticating(false);
  }
  async function handleLogout() {
    await Auth.signOut();
    history.push("/login");
    userHasAuthenticated(false);
  }
  return (
    !isAuthenticating &&(<div className="App container py-3">
      <Navbar collapseOnSelect bg="light" expand="md" className="mb-3">
       <LinkContainer to="/">
          <Navbar.Brand className="font-weight-bold text-muted">
              Scratch
          </Navbar.Brand>
       </LinkContainer> 
        <Navbar.Toggle />
        <Navbar.Collapse className="justify-content-end">
          <Nav activeKey={window.location.pathname}>
          {isAuthenticated ? ( <>
                              <LinkContainer to="/settings">
                                  <Nav.Link>Settings</Nav.Link>
                                </LinkContainer>
                               <Nav.Link onClick={handleLogout}>Logout</Nav.Link>
                               </>
                              ) : (
                                                  <>
                                                    <LinkContainer to="/signup">
                                                      <Nav.Link>Signup</Nav.Link>
                                                    </LinkContainer>
                                                    <LinkContainer to="/login">
                                                      <Nav.Link>Login</Nav.Link>
                                                    </LinkContainer>
                                                  </>
                                  )
          }
          </Nav>
        </Navbar.Collapse>
      </Navbar>
      <AppContext.Provider value={{isAuthenticated, userHasAuthenticated }} >
        <Routes />
      </AppContext.Provider>
      
    </div>)
  );
}

export default App;
